// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"23843af3","386":"4e2dd4dc","453":"4df1489e","567":"1341baef"}[chunkId] + ".chunk.js";
};